import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';
import { SortOptions } from '~src/spacesPlatform/models/sort/CommonSortOptions';
import { OptionsDictionary } from '~src/spacesPlatform/models/sort/SortOptionDefinitions';

import { CRASSSortOptions } from './CrassSortOptions';

export const databaseWithCRASSSortOptions: OptionsDictionary = getOptions();

function getOptions(): OptionsDictionary{
  return (FeatureFlags.databasesInProjectsPostMVPEnabled && FeatureFlags.databasesInProjectsEnabled) ? {
    'relevance': SortOptions.relevance,
    'name': SortOptions.name,
    'workbooks': CRASSSortOptions.downstreamWorkbookCount,
    'datasources': CRASSSortOptions.downstreamDataSourceCount,
    'connectionType': CRASSSortOptions.connectionType,
    'containerName': CRASSSortOptions.containerName
  }: {
    'relevance': SortOptions.relevance,
    'name': SortOptions.name,
    'workbooks': CRASSSortOptions.downstreamWorkbookCount,
    'datasources': CRASSSortOptions.downstreamDataSourceCount,
    'connectionType': CRASSSortOptions.connectionType,
  };
}